import { Contact } from '@api/generated/graphql';
import { Icon, TableCellProps } from '@servicetitan/design-system';
import React from 'react';

interface NotificationValueCellProps extends TableCellProps {
  dataItem: any; // Adjust the type as needed
}

const NotificationValueCell: React.FC<NotificationValueCellProps> = (props) => {
  const isNotificationEnabled = (contact: Contact) => {
    return (
      contact.jobRemindersEnabled ||
      contact.marketingUpdatesEnabled ||
      contact.invoiceStatementNotification
    );
  };
  return (
    <td colSpan={props.colSpan} className={props.className}>
      <div className='ta-center'>
        {isNotificationEnabled(props.dataItem) ? (
          <Icon name='notifications' color='green' />
        ) : (
          <Icon name='notifications_off' color='red' />
        )}
      </div>
    </td>
  );
};

export default NotificationValueCell;
